import type { TextComponentSpec } from "../../Processing/types";

export interface TextFormState {
  content: string;
}

export type TextAction = { type: "SET_CONTENT"; content: string };

export function textReducer(state: TextFormState, action: TextAction): TextFormState {
  switch (action.type) {
    case "SET_CONTENT":
      return { ...state, content: action.content };
    default:
      return state;
  }
}

// Starter content for new text widgets, demonstrating formatting and dynamic
// variables. Stored as the widget's content unless the user clears it. Existing
// widgets load via hydrateFromSpec and are unaffected.
const TUTORIAL_CONTENT =
  `<p style="text-align: right">New here? Tap <strong>Preview</strong> (top-right) to watch this come to life.</p>` +
  `<h2 style="text-align: center">Your {CurrentMonth} {CurrentYear} Report</h2>` +
  `<p>Welcome to your <strong>Text Widget</strong>, a blank canvas for <em>notes</em>, summaries, and the odd <mark data-color="#ffe58f" style="background-color: #ffe58f; color: inherit">victory lap</mark>. Go <strong>bold</strong>, <em>italic</em>, <u>underline</u> it, or splash on some <span style="color: #c0392b">color</span>.</p>` +
  `<p>Line things up however you like:</p>` +
  `<p>Left for the classics</p>` +
  `<p style="text-align: center">Center for the big moments</p>` +
  `<p style="text-align: right">Right for the rebels</p>` +
  `<p>Stack up the essentials:</p>` +
  `<ul><li>Training load (the kind that actually loads)</li><li>Sleep, stress &amp; readiness</li><li>Notes the staff <em>swear</em> they'll read</li></ul>` +
  `<p>The fun part? <strong>Dynamic variables</strong> that keep themselves honest: today is {CurrentDate:MMMM D, YYYY}, last month was {CurrentMonth-1}, and it'll still be right next month. Open the Variables menu to quote a slicer's dates or athletes.</p>`;

export function createInitialState(): TextFormState {
  return { content: TUTORIAL_CONTENT };
}

export function hydrateFromSpec(spec: TextComponentSpec): TextFormState {
  return { content: spec.display.content };
}

export function formStateToSpec(state: TextFormState): TextComponentSpec | null {
  return {
    type: "text",
    display: { content: state.content },
  };
}
